import React, {useState} from "react";
import {Popup} from "devextreme-react/popup";
//import {Button} from "devextreme-react/button";
//import {FileSignatureCriptoPro} from "./FileSignatureCriptoPro.stories";
import ScrollView from "devextreme-react/scroll-view";
import {PopupTitleWithIcon} from "../popup-title-with-icon/popup-title-with-icon";
import {faKey} from "@fortawesome/free-solid-svg-icons";
import { getDogovorToSigned } from "../../api/newdog";
import PopMainCert from "./PopMainCert";
import {VerifySignature_Async} from './utils'
import {Button} from "devextreme-react/button";
import notify from "devextreme/ui/notify";
const toBase64 = file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

const PopSelectCert = (props) => {
    const [popupVisible, setPopupVisible] = useState(false);
    const [filesForSignature, setFilesForSignature] = useState(null)
    const [companyKey, setCompanyKey] = useState(null)
    const [filePdfName, setFilePdfName] = useState(null)
    const [result, setResult] = useState({result: null, isOk: true})
    const envTat = process.env.REACT_APP_NAME_ENV === 'tatenergosbyt';
    const type = props.clientKey ? 'danger':'success'
    const showPop = async () => {
        try {
            setPopupVisible(true)
            const fileToSigned = await getDogovorToSigned(props.idFile)
            if (!fileToSigned.isOk) {
                notify(fileToSigned.message || 'Не удалось загрузить документ', 'error', 5000)
                setPopupVisible(false)
                return
            }
            let blob = new Blob([new Uint8Array(fileToSigned.data.dogovor.attachment.data)], {type: "application/pdf"});
            let file = new File([blob], fileToSigned.data.dogovor.filename, {type: "application/pdf"});
            if (fileToSigned.data.dogovor.filename.includes('.pdf')){
                setFilePdfName(fileToSigned.data.dogovor.filename.replaceAll(/\.pdf/gi,'_signed.pdf'))
            }
            setResult({isOk: true, result: ''})//для ТЭС
            if (props.companyKeyName && fileToSigned.data.dogovor.companyKey && !envTat && window.cadesplugin?.CreateObjectAsync){
                let f = new Blob([new Uint8Array(fileToSigned.data.dogovor.attachment.data)]);
                let sBase64Data = await toBase64(f)
                sBase64Data = sBase64Data.replaceAll(/(^.*?base64,)/gi,'')

                let t = new Blob([new Uint8Array(fileToSigned.data.dogovor.companyKey.data)]);
                let companySig = await toBase64(t)
                companySig = companySig.replaceAll(/(^.*?base64,)/gi,'')
                setCompanyKey(companySig)
                try {
                    const rezVerify = await VerifySignature_Async(sBase64Data, companySig)
                    if (rezVerify) {
                        setResult(rezVerify)
                    }
                } catch (e) {
                    // Плагин ещё не готов — пропускаем предварительную проверку подписи компании
                }
            }
            setFilesForSignature([file]);
        } catch (e) {
            notify(e?.message || 'Ошибка при открытии подписания', 'error', 5000)
            setPopupVisible(false)
        }
    }

    const hidePop = () => {
        setPopupVisible(false)
    }
    return (
        <>
            {!props.clientKey ?
                <Button type={type} id={`btn${props.idFile}`} icon={'images/flash.svg'} hint={!props.clientKey ? 'Подписать документ' : 'Документ подписан'} onClick={!props.clientKey ? showPop : () => notify("Документ подписан", 'success', 2000)}></Button>
                :
                <span title='Документ подписан' className='p-2 success'><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.58681 16.5962L1.96378 18L10.982 8.80608C11.6929 9.23774 12.505 9.47589 13.3573 9.47589C14.5983 9.47589 15.7662 8.9847 16.6422 8.08698C18.4526 6.24129 18.4526 3.2346 16.6422 1.38891C15.7662 0.495838 14.5982 2.01491e-06 13.3573 1.90642e-06C12.1164 1.79794e-06 10.9484 0.491193 10.0724 1.38891C8.45629 3.03646 8.28658 5.61137 9.55679 7.45706L6.07728 11.0044L4.56891 9.4666L3.19194 10.8704L4.70031 12.4082L2.88534 14.2585L1.37697 12.7207L-9.26741e-07 14.1245L1.50837 15.6623L0.588561 16.6L0.58681 16.5962ZM11.4447 2.79259C11.9557 2.27163 12.6318 1.98882 13.3527 1.98882C14.0727 1.98882 14.7543 2.27627 15.2608 2.79259C16.312 3.86428 16.312 5.61042 15.2608 6.68759C14.7498 7.20855 14.0736 7.49136 13.3527 7.49136C12.6328 7.49136 11.9511 7.20391 11.4446 6.68759C10.3934 5.6159 10.3934 3.86976 11.4447 2.79259Z"/>
                    </svg></span>
            }
            <Popup
                visible={popupVisible}
                dragEnabled={true}
                hideOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title="Подпись файла(-ов)"
                maxWidth={600}
                maxHeight={'90%'}
                height={'auto'}
                onHiding={hidePop}
                titleRender={()=>PopupTitleWithIcon(faKey, "Подпись файла договора",hidePop)}
            >
                <ScrollView width='100%' height='100%'>
                <PopMainCert rezVerify={result} files={filesForSignature} companyKey={companyKey} filePdfName={filePdfName} idFile={props.idFile} onSuccessSign={() => {
                    setPopupVisible(false);
                    props.onSuccessSign()
                }
                }/>
                </ScrollView>
            </Popup>
        </>)

};

export default PopSelectCert;
